import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { styled } from '@mui/system'

export const TableContainer = styled('div')`
    margin-top: 16px;
`

export const HeaderText = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'minWidth',
})<{
    theme?: TTheme
    minWidth?: string
}>`
    margin: 12px 0;
    min-width: ${({ minWidth }) => minWidth || '110px'};
`

export const Cell = styled('div', {
    shouldForwardProp: (prop) => prop !== 'minWidth',
})<{
    theme?: TTheme
    minWidth?: string
}>`
    cursor: pointer;
    min-width: ${({ minWidth }) => minWidth || 'auto'};
    display: flex;
    align-items: center;
    padding-top: 20px;
    padding-bottom: 20px;
`
